import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  BoxProps,
  CloseButton,
  useDisclosure,
} from '@chakra-ui/react';
import { AnimatePresence, motion } from 'framer-motion';
import { ReactNode } from 'react';

interface IOwnProps extends BoxProps {
  title?: string;
  children: string | ReactNode;
}

const MotionBox = motion(Box);

const AlertMobile: React.FC<IOwnProps> = ({ children, title, ...rest }) => {
  const { isOpen: isVisible, onClose } = useDisclosure({ defaultIsOpen: true });

  return (
    <Box mx={3} {...rest}>
      <AnimatePresence>
        {isVisible && (
          <MotionBox
            borderRadius="md"
            overflow="hidden"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.5, ease: 'easeInOut' }}
          >
            <Alert
              status="info"
              borderRadius="md"
              boxShadow="md"
              px={5}
              pb={5}
              bg="blue.50"
              color="blue.800"
              flexDirection="column"
              alignItems="center"
              textAlign="center"
            >
              <AlertIcon boxSize="32px" mb={2} color="blue.600" display={{ base: 'none', md: 'block' }} />
              <CloseButton
                alignSelf="flex-start"
                position="absolute"
                right={1}
                top={1}
                color="blue.600"
                onClick={onClose}
              />
              {title && (
                <AlertTitle fontSize="sm" fontWeight="bold" textTransform="uppercase" letterSpacing="wide" mb={1}>
                  {title}
                </AlertTitle>
              )}
              {(typeof children == 'string' && (
                <AlertDescription
                  fontSize="12px"
                  lineHeight={4}
                  textAlign="start"
                  maxW="sm"
                  dangerouslySetInnerHTML={{ __html: children }}
                />
              )) || (
                <AlertDescription fontSize="12px" lineHeight={4} textAlign="start" maxW="sm">
                  {children}
                </AlertDescription>
              )}
            </Alert>
          </MotionBox>
        )}
      </AnimatePresence>
    </Box>
  );
};

export default AlertMobile;
